/** @jsx jsx */
/* eslint-disable no-use-before-define */
import 'react'
import {jsx, css} from '@emotion/core'
import {mediaQueries} from '../twd'

export default ({name, rating, setRating, align='right'} = {}) => {
    let css = align==='right'
        ? {css:textAlignRight}
        : {}
    return <div {...css}>
    <fieldset>
    <div className="radio radio-inline">
        <input type="radio"
            data-name={name + '-investment-grade'}
            id={name + '-investment-grade'}
            name={name}
            checked={rating==='INVESTMENT_GRADE'}
            onChange={() => setRating('INVESTMENT_GRADE')} />
        <label htmlFor={name + '-investment-grade'}>Investment Grade</label>
    </div>

    <div className="radio radio-inline">
        <input type="radio"
            data-name={name + '-high-yield'}
            id={name + '-high-yield'}
            name={name}
            checked={rating==='HIGH_YIELD'}
            onChange={() => setRating('HIGH_YIELD')} />
        <label htmlFor={name + '-high-yield'}>High Yield</label>
    </div>
    </fieldset>
    </div>
}

const textAlignRight = css`
    ${mediaQueries.notXs} { text-align: right }
`


// WEBPACK FOOTER //
// ./src/corporates/rating-fieldset.js